<script>
import Snackbar from '@/components/Messages/Snackbar'
import { SNK } from '@/helpers/helpers'
import GmfSelektorRows from '@/components/GameFormat/GmfSelektor/GmfSelektorRows'
import GmfSelektorStacksTable from '@/components/GameFormat/GmfSelektor/GmfSelektorStacksTable'
import GmfPreview from '@/components/GameFormat/GmfSelektor/GmfPreview'

export default {
  name: 'GmfSelektor',
  components: {
    GmfSelektorRows,
    GmfSelektorStacksTable,
    GmfPreview,
    Snackbar,
  },
  props: {
    namespace: { String, required: true },
    hideLecacyGmfs: { type: Boolean, default: true },
    hasPreview: { type: Boolean, default: true },
    channelId: String,

    hasLogo: Boolean,
    hasTableKeydown: Boolean,
    instaApply: Boolean,
    keepHistoryTree: Boolean,
    routerParams: {
      default: () => ({
        push: false,
        replace: false,
        saveLocally: false,
      }),
    },
  },
  emits: ['gmf:update', 'table:click'],
  data() {
    return {
      loadingGmf: false,
    }
  },
  created() {
    // to fix going from Live trainer to study mode and back and openning the selector
    if (this.$route.name === 'StudySolutions') {
      this.$store.dispatch(SNK('gmfs_checkForRecomputeBase', this.namespace))
    }
  },
  methods: {
    async handleUpdateSub(item) {
      if (item.id === 'group') {
        const modes = {
          mtt: 'MTT',
          spins: 'Spins',
          husng: 'HuSng',
          cash: 'Cash',
        }
        const selectedItem = item.selected[0]
        const mode = modes[selectedItem]

        if (!this.$store.getters.gameformats_groupsSet[mode]) {
          this.loadingGmf = true
          const result = await this.$store.dispatch('get_gameformat_groups', [mode])
          if (!result || result.error) return
        }

        item.conf =
          this.$store.state.gameformat[
            this.$store.getters[SNK('gmfs_tableMultiselect', this.namespace)]()
              ? 'gameformats_nested_study'
              : 'gameformats_nested_trainer'
          ]
      }

      if (item.id === 'group' && this.hasLists) {
        this.emptyLists()
      }
      if (this.keepHistoryTree) {
        this.$store.dispatch('globals_action', 'disable_history_watcher')
        setTimeout(() => {
          this.$store.dispatch(SNK('gmfs_update_sub', this.namespace), {
            item,
            instaApply: this.instaApply,
            routerParams: this.routerParams,
            keepHistoryTree: this.keepHistoryTree,
            hasLists: this.hasLists,
            channelId: this.channelId,
          })

          this.$emit('gmf:update', item)
          this.loadingGmf = false
        })
        return
      }
      this.$store.dispatch(SNK('gmfs_update_sub', this.namespace), {
        item,
        instaApply: this.instaApply,
        routerParams: this.routerParams,
        keepHistoryTree: this.keepHistoryTree,
        hasLists: this.hasLists,
        channelId: this.channelId,
        // storeAction,
      })
      this.$emit('gmf:update', item)
      this.loadingGmf = false
    },
    emptyLists() {
      const applyArgs = {
        instaApply: this.instaApply,
        routerParams: this.routerParams,
        hasLists: this.hasLists,
        channelId: this.channelId,
      }
      const lists = ['gmfs_avgStackList', 'gmfs_depthList', 'gmfs_stacksList']
      lists.forEach(listKey => {
        this.$store.dispatch(SNK('gmfs_toggle_list', this.namespace), {
          listKey,
          empty: true,
          ...applyArgs,
        })
      })
    },
    apply({ namespace = this.namespace, routerParams = this.routerParams } = {}) {
      this.$store.dispatch('globals_action', 'disable_history_watcher')
      setTimeout(() => {
        const storeAction = SNK('gmfs_apply', namespace)
        this.$store.dispatch(storeAction, {
          routerParams,
          keepHistoryTree: this.keepHistoryTree,
          hasLists: this.hasLists,
          channelId: this.channelId,
        })
      })
    },
  },
  computed: {
    hasLists() {
      return this.$store.getters[SNK('gmfs_tableMultiselect', this.namespace)]()
    },
    l_gameformat() {
      return this.$store.getters[SNK('gmfs_gameformat', this.namespace)]
    },
    infoKey() {
      return `cash_${this.l_gameformat?.cash_type}` || this.l_gameformat?.format
    },
    gameInfo() {
      const texts = {
        cash_ante_straddle: 'tooltips.gmf_ante_straddle',
        cash_ante: 'tooltips.gmf_ante',
        chipev: 'tooltips.gmf_mtt_chipev01',
      }
      const res = texts[this.infoKey]
      if (!res) return ''
      return this.$t(res)
    },
    isICM() {
      return this.l_gameformat?.format === 'icm'
    },
    isICM_PKO() {
      return this.l_gameformat?.format === 'icm' && this.l_gameformat?.tournament_type === 'pko'
    },
    mobile() {
      return this.$store.getters.globals_mobile
    },
  },
}
</script>

<template>
  <div
    class="gmfslctr"
    :class="{ gw_loading: loadingGmf }"
    style="--loading_text-z-index: 5"
    :data-tst="loadingGmf ? 'gmf_loading' : 'gmf_loaded'"
  >
    <div class="gmfslctr_box gmfslctr_left no-scroll-track">
      <GmfSelektorRows
        :rows="$store.getters[`${namespace ? `${namespace}/` : ''}gmfs_beforeTableRows`].game"
        :gameformat="l_gameformat"
        @update:sub="item => handleUpdateSub(item)"
      />
      <Snackbar
        v-if="gameInfo"
        ref="snackbar"
        :oneTimeOnly="true"
        :localKey="`gmf_postflop_info_banner_${infoKey}`"
        class="d-flex w-100 mb-2 mt-4 gw_loading_text"
        style="
          --position: relative;
          --clr-back: #29261e;
          padding: 0.5rem 1rem;
          --close-inset: 0.125rem 0.125rem auto auto;
          max-width: 100%;
          --close-padding: 0.25rem;
          --close-size: 1rem;
        "
      >
        <div class="d-flex clr-yellow text-small">
          <div v-html="gameInfo"></div>
        </div>
      </Snackbar>
    </div>
    <div class="gmfslctr_box gmfslctr_center no-scroll-track">
      <GmfSelektorStacksTable
        class="gmfslctr_center_right_center gw_loading_text"
        style="min-height: 0; display: flex; flex-direction: column"
        v-bind="$store.getters[`${namespace ? `${namespace}/` : ''}gmfs_tableConf`]"
        :namespace="namespace"
        :instaApply="instaApply"
        :routerParams="routerParams"
        :keepHistoryTree="keepHistoryTree"
        :hasLists="hasLists"
        :channelId
        :hasKeydown="hasTableKeydown"
        :gameformat="l_gameformat"
        @gmf:update="v => $emit('gmf:update', v)"
        @table:click="$emit('table:click')"
      >
        <template #before>
          <GmfSelektorRows
            style="padding: 0 0 1em 0"
            class="gmfslctr_center_right_top gw_loading_text"
            :rows="
              $store.getters[`${namespace ? `${namespace}/` : ''}gmfs_beforeTableRows`].rightTop
            "
            :gameformat="l_gameformat"
            @update:sub="item => handleUpdateSub(item)"
          />
        </template>
        <template #after>
          <GmfSelektorRows
            v-if="$store.getters[`${namespace ? `${namespace}/` : ''}gmfs_rightBottom`]"
            style="padding: 1em 0 0 0"
            class="gmfslctr_center_right_bottom gw_loading_text"
            :rows="$store.getters[`${namespace ? `${namespace}/` : ''}gmfs_rightBottom`]"
            :gameformat="l_gameformat"
            @update:sub="item => handleUpdateSub(item)"
          />
        </template>
      </GmfSelektorStacksTable>
    </div>
    <div
      v-if="hasPreview"
      class="gmfslctr_box gmfslctr_right"
    >
      <GmfPreview
        :gameformat="l_gameformat"
        style="min-width: var(--preview-min-width); max-width: var(--preview-min-width)"
      >
        <div
          class="clr-grey uppercase"
          style="font-size: 0.875em"
        >
          {{ $t('common.preview') }}
        </div>
        <div
          v-if="isICM && mobile"
          class="gw_btn gw_btn_text gw_btn_outline gmfslctr_left_payouts clr-grey mr-auto mt-2 weight_500"
          @click="$store.dispatch('router_set_dialogs', 'payouts-dialog')"
        >
          <i class="mdi mdi-currency-usd text-semi-large mr-1"></i>
          {{ $t('common.payouts') }}
        </div>
      </GmfPreview>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.gmfslctr {
  --gmfslctr-wrap: nowrap;
  display: flex;
  flex-wrap: var(--gmfslctr-wrap);
  align-content: flex-start;

  min-height: 0;
  border-radius: 4px;

  z-index: 99;
  overflow: auto;
  max-width: 100vw;
  gap: 1em;
  position: relative;

  --min-width: auto;
  --min-height: 24em;

  --center-width: clamp(37em, 39em, 100vw);
  --preview-min-width: clamp(12rem, 22em, 100vw);

  min-height: var(--min-height);
  &_logo {
    flex: 1;
    fill: rgba(255, 255, 255, 0.025);
    svg {
      height: 100%;
      position: fixed;
    }
  }
  &_box {
    display: flex;
    min-width: var(--min-width);
    min-height: var(--min-height);
    min-height: 0;
    flex-shrink: 0;
    max-width: clamp(100%, 100%, 100vw);
    max-height: 100%;
    overflow-y: auto;
    overflow-x: hidden;
  }
  &_column {
    flex-direction: column;
    .gmfslctr_box {
      border-right: none;
      border-left: none;
      padding: 0;
    }
    .gmfslctr_right {
      background: transparent;
    }
  }

  &_left {
    flex-direction: column;
    width: clamp(1px, 20em, 100vw);
    &_info {
      font-size: 0.8em;
      color: var(--clr-grey-2);
      padding: 1em 0;
      max-width: 20em;
      max-width: 20em;
    }
  }
  &_center {
    min-width: 0;
    width: var(--center-width);
    flex-direction: column;
    gap: 1em;
    flex: 1;
    min-width: clamp(1px, 33em, 100%);
  }
  &_right {
    max-height: 100%;
    background: var(--clr-black-1-1);
    padding: 1em;
  }
}

@media (max-width: 1023px) {
  .gmfslctr {
    flex-direction: column;
    padding: 1em 0;
    overflow-x: hidden;
    overflow-y: auto;
    &_box {
      padding: 0 1em;
      max-height: unset;
    }
    &_center {
      flex: none;
    }
    &_right {
      margin: 0.75em 0 -1em 0;
      padding: 1em;
      border-radius: 0px;
      min-width: 100%;
      display: flex;
    }
    &_preview {
      margin-right: auto;
    }
  }
}
</style>
